<template>
  <div>
    <CRow class="align-items-center">
      <CCol md="6" class="mb-4">
        <CRow>
          <CCol col="12" class="mb-4">
            <label v-translate translate-context="qrcode.label">Image Type</label>
            <div class="btn-group-squared btn-group-toggle">
              <label class="btn btn-outline-secondary btn-toggle" v-for="(type, index) in qrCodeType" :key="index"
                     :class="{'active': renderAs === type.value}">
                <input type="radio" name="logo-size"
                       :id="`option-${index}`"
                       v-model="renderAs"
                       :value="type.value"
                       :checked="type.value === renderAs">
                {{ type.label }}
              </label>
            </div>
          </CCol>
          <CCol col="12">
            <label v-translate translate-context="qrcode.label">Background color</label>
            <PColorPicker :color="background"
                          disable-alpha
                          @change="color => background = color.hex"/>

          </CCol>
          <CCol col="12">
            <label v-translate translate-context="qrcode.label">Foreground color</label>
            <PColorPicker :color="foreground"
                          disable-alpha
                          @change="color => foreground = color.hex"/>
          </CCol>
        </CRow>
      </CCol>

      <CCol md="6" class="mb-4">
        <div class="border p-2" style="border-radius: 6px">
          <qrcode-vue
              ref="qrcode"
              :value="value"
              :size="size"
              :render-as="renderAs"
              :background="background"
              :foreground="foreground"
          />
        </div>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import QrcodeVue from 'qrcode.vue'
import {downloader} from "@/domain/core/components/qrcode/downloader";
import PColorPicker from "@/domain/core/components/PColorPicker.vue";

const qrCodeType = [
  {
    label: 'SVG',
    value: 'svg'
  },
  {
    label: 'PNG',
    value: 'canvas'
  }
]

export default {
  name: "QRCodeGenerator",
  components: {PColorPicker, QrcodeVue},
  props: {
    value: {
      type: String,
      required: true
    },
    fileName: {
      type: String,
      default: 'QRCode'
    }
  },
  created() {
    this.qrCodeType = qrCodeType
  },
  data() {
    return {
      size: 200,
      renderAs: 'svg',
      background: '#ffffff',
      foreground: '#000000'
    }
  },
  methods: {
    download() {
      if (this.renderAs === 'svg') {
        const qrcode = this.$refs.qrcode.$el.querySelector('svg')
        downloader.fromSvg(qrcode, this.fileName + '.svg')
      } else {
        const qrcode = this.$refs.qrcode.$el.querySelector('canvas')
        downloader.fromPngCanvas(qrcode, this.fileName + '.png')
      }
    },
  },
}
</script>